import { render, staticRenderFns } from "./borrower-confirm-modal.vue?vue&type=template&id=84d3a66c&"
import script from "./borrower-confirm-modal.vue?vue&type=script&lang=ts&"
export * from "./borrower-confirm-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports